import { useMemo, useRef, useState } from 'react';
import clsx from 'clsx';
import { PaletteUtils } from '@shared/utils';

type TabProps<T extends string | number> = {
  value: T;
  title: string;
  label?: React.ReactNode;
};

interface ITabsProps<T extends string | number> {
  className?: string;
  classNameCaption?: string;
  loading?: boolean;
  options?: TabProps<T>[];
  value?: T;
  onChange?: (value: T) => void;
}

export const Tabs = <T extends string | number>(props: ITabsProps<T>) => {
  const [indexState, setIndex] = useState(0);
  const refContainer = useRef<HTMLUListElement>(null);

  const index = useMemo(() => {
    if (props.value && props.options) return props.options.findIndex((item) => item.value === props.value);
    else return indexState;
  }, [props.value, props.options, indexState]);

  return (
    <ul className={clsx('flex h-[74px] items-center', props.className)} ref={refContainer}>
      {props.options?.map((item, idx) => (
        <li
          key={idx}
          className={clsx(
            'cursor-pointer transition-opacity duration-300',
            idx === index && 'cursor-default opacity-100 border-b',
            idx === index && (PaletteUtils.isBordierPalette ? 'text-[#dc291c]' : 'text-[#be8b45]'),
          )}
          onClick={() => (props.onChange ? props.onChange(item.value) : setIndex(idx))}
        >
          <div className={clsx('flex items-center gap-2 px-5 text-lg py-7 ', props.classNameCaption)}>
            {item.label}
            {item.title}
          </div>
        </li>
      ))}
    </ul>
  );
};
